import { t as e } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { createElementBlock as t, openBlock as n, toDisplayString as r } from "vue";
//#region recipes/conversation_view/time_pill/time_pill.vue
var i = {
	compatConfig: { MODE: 3 },
	name: "DtRecipeTimePill",
	props: {
		dateTimeDisplay: {
			type: String,
			required: !0
		},
		dateTime: {
			type: String,
			required: !0,
			validator: (e) => {
				let t = new Date(e);
				return t instanceof Date && !isNaN(t);
			}
		}
	}
}, a = ["dateTime"];
function o(e, i, o, s, c, l) {
	return n(), t("time", {
		"data-qa": "dt-recipe-time-pill",
		dateTime: o.dateTime,
		class: "d-recipe-time-pill"
	}, r(o.dateTimeDisplay), 9, a);
}
var s = /* @__PURE__ */ e(i, [["render", o]]);
//#endregion
export { s as default };

//# sourceMappingURL=time-pill.js.map